module.exports = __webpack_public_path__ + "static/img/core2.c327a126.png";